import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from '@mui/material';

const DeleteMemberDialog = ({open, member, onClose, onConfirm}) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Mitglied löschen?</DialogTitle>
            <DialogContent>
                <Typography>
                    Möchten Sie das Mitglied "{member?.firstName} {member?.lastName}" wirklich löschen?
                    Diese Aktion kann nicht rückgängig gemacht werden.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Abbrechen</Button>
                <Button onClick={onConfirm} variant="contained" color="error">
                    Löschen
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteMemberDialog;

